<div
  class="group relative flex items-center gap-2 rounded-md py-1.5"
  [ngClass]="{
    'bg-surface-page transition-all duration-300 ease-in-out hover:bg-hover hover:pr-7 hover:pl-2':
      item.correction && canDelete,
  }"
  [sbTooltip]="tooltipTemplate"
  [sbTooltipDisabled]="!item.correction"
  [sbTooltipPlacement]="'left'"
  [sbTooltipMaxWidth]="'18rem'"
>
  <span class="flex-1">{{ item.label }}</span>
  <span>
    {{ item.sign }} {{ item.value }}
    @if (item.moreDetails) {
      ({{ item.moreDetails }})
    }
  </span>
  @if (item.correction && canDelete) {
    <span
      class="absolute -right-2 opacity-0 transition-all duration-300 ease-in-out group-hover:right-0 group-hover:opacity-100"
    >
      <button
        sbActionConfirm
        sb-icon-button
        color="transparent"
        size="sm"
        (confirmed)="deleteCorrection(item.correction.id)"
      >
        <sb-icon name="delete-2-regular" size="sm" />
        <span class="sr-only">{{ 'Delete correction' | translate }}</span>
      </button>
    </span>
  }
</div>
<ng-template #tooltipTemplate>
  <div class="flex flex-col gap-4 text-sm font-semibold text-overlay-strong">
    <div class="flex gap-2">
      <sb-badge-icon
        class="bg-surface text-support"
        [size]="'xl'"
        [name]="correctionTypeMap[item.correctionType].icon"
      ></sb-badge-icon>
      <div class="flex flex-col">
        <span>{{ correctionTypeMap[item.correctionType].label }}</span>
        <span class="text-xs font-medium" data-hj-suppress>{{ 'by' | translate }} {{ item.correction.createdBy }}</span>
      </div>
    </div>
    <div class="flex justify-between gap-10">
      <span>{{ 'Correction date' | translate }}</span>
      <span>{{ item.correction.date | localeDate }}</span>
    </div>
    @if (item.correction.pay) {
      <div class="flex justify-between gap-10">
        <span>{{ 'Payout date' | translate }}</span>
        <span>{{ item.correction.payoutDate | localeDate }}</span>
      </div>
    }
    <div class="flex justify-between gap-10">
      <span>{{ 'Created on' | translate }}</span>
      <span>{{ item.correction.created | localeDate: 'dateTimeShort' }}</span>
    </div>
    @if (item.correction.note) {
      <hr sbTooltipDivider />
      <div class="flex gap-2">
        <sb-icon name="notepad" />
        <span data-hj-suppress>{{ item.correction.note }}</span>
      </div>
    }
  </div>
</ng-template>
